import('./generated/scala-js/main.js');
